import React from 'react';
import YouTubeEstimateTooltip from '../YouTubeEstimateTooltip';

const MetricCard = ({
  icon: Icon,
  label,
  value,
  sublabel,
  change,
  color = 'indigo',
  highlight = false,
  youtubeEstimate = null // 'engagement', 'watchHours', 'impressions', or null
}) => {
  const colorClasses = {
    indigo: 'bg-sc-pink/10 text-sc-pink',
    purple: 'bg-purple-50 text-purple-600',
    green: 'bg-green-50 text-green-600',
    blue: 'bg-sc-pink/10 text-sc-pink',
    orange: 'bg-orange-50 text-orange-600',
    red: 'bg-red-50 text-red-600'
  };

  return (
    <div className={`card-pink-accent bg-white rounded-xl border p-4 ${highlight ? 'border-green-300 ring-1 ring-green-100' : 'border-gray-200'}`}>
      <div className="flex items-center justify-between">
        <div className={`p-2 rounded-lg ${colorClasses[color]}`}>
          {Icon && <Icon className="w-5 h-5" />}
        </div>
        {change && (
          <span className={`text-sm font-medium ${change.isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {change.value}
          </span>
        )}
      </div>
      <div className="mt-3">
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <div className="flex items-center gap-1.5 mt-1">
          <p className="text-sm text-gray-500">{label}</p>
          {youtubeEstimate && <YouTubeEstimateTooltip metric={youtubeEstimate} />}
        </div>
        {sublabel && (
          <p className="text-xs text-gray-400 mt-0.5">{sublabel}</p>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
